const EN = {
    document: 'Document',
    role: 'Role',
    email: 'Email',
    status: {
        1: 'Pending',
        2: 'Active',
        3: 'Recover',
        4: 'Blocked',
        5: 'Inactive',
        9: 'Information',
        10: 'Information',
        11: 'In Revision',
        'admin.natura': 'Admin',
        'operator.natura': 'Operator',
        'ext-support-operator.natura': 'External Operator',
        'fraud_prevention_analyst.natura': 'Fraud prevention operator',
        'fraud_prevention_admin.natura': 'Fraud prevention admin',
        'user_admin.natura': 'User Admin',
        'customer.natura': 'Customer'
    }
};

export default EN;
